const FIRST = [
  'Brass',
  'Copper',
  'Iron',
  'Quiet',
  'Swift',
  'Rusty',
  'Amber',
  'Cinder',
  'Velvet',
  'Foggy',
  'Steady',
  'Lucky',
  'Sooty',
  'Gilded',
  'Midnight',
  'Clockwork',
  'Restless',
  'Nimble',
  'Patient',
  'Hollow',
];

const SECOND = [
  'Sparrow',
  'Lark',
  'Wren',
  'Kestrel',
  'Piston',
  'Cog',
  'Gasket',
  'Lantern',
  'Spindle',
  'Rivet',
  'Valve',
  'Compass',
  'Sprocket',
  'Fox',
  'Otter',
  'Magpie',
  'Whistle',
  'Ledger',
  'Bellows',
  'Flywheel',
];

export const MAX_RUNNER_NAME_LENGTH = 40;

export function suggestCallsign(random: () => number = Math.random): string {
  const pick = (words: readonly string[]): string =>
    words[Math.min(words.length - 1, Math.floor(random() * words.length))]!;
  return `${pick(FIRST)} ${pick(SECOND)}`;
}

export function normalizeRunnerName(raw: string): string | null {
  const name = raw.trim().replace(/\s+/g, ' ');
  return name.length === 0 || name.length > MAX_RUNNER_NAME_LENGTH ? null : name;
}
